import { render, staticRenderFns } from "./Checks.vue?vue&type=template&id=5616c636"
import script from "./Checks.vue?vue&type=script&lang=js"
export * from "./Checks.vue?vue&type=script&lang=js"
import style0 from "./Checks.vue?vue&type=style&index=0&id=5616c636&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports